export const ColumnManagerTranslationFallbackKeys = {
  columns: "columns",
  visibleColumns: "Visible Columns",
  hiddenColumns: "hidden columns",
  pinnedColumns: "pinned columns",
  noColumnsMatch: "no columns match",
  searchPlaceholder: "Search columns...",
} as const
